import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminNewsletter() {
  const [subs, setSubs] = useState([]);
  const [form, setForm] = useState({ subject: "", html_content: "" });
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/admin/newsletter").then(r=>setSubs(r.data)); }, []);
  const send = async (e) => {
    e.preventDefault();
    if (!window.confirm(`Envoyer à ${subs.length} abonné(e)s ?`)) return;
    setLoading(true);
    try { const r = await api.post("/admin/newsletter/send", form); toast.success(`Envoyé à ${r.data.sent} abonné(e)s ✿`); setForm({subject:"",html_content:""}); }
    catch { toast.error("Erreur"); }
    finally { setLoading(false); }
  };
  return (
    <div className="p-4 sm:p-6 lg:p-10">
      <p className="overline text-berulia-rosedeep">BERULIA</p>
      <h1 className="font-heading text-3xl sm:text-4xl mt-2 mb-8">Newsletter</h1>
      <div className="grid lg:grid-cols-3 gap-6">
        <form onSubmit={send} className="lg:col-span-2 bg-white border border-berulia-border p-6 space-y-4">
          <label className="block"><span className="overline">Objet</span><input data-testid="news-subject" required value={form.subject} onChange={e=>setForm({...form, subject:e.target.value})} className="mt-1 w-full border border-berulia-border px-3 py-2"/></label>
          <label className="block"><span className="overline">Contenu HTML</span><textarea data-testid="news-html" required rows={12} value={form.html_content} onChange={e=>setForm({...form, html_content:e.target.value})} className="mt-1 w-full border border-berulia-border px-3 py-2 font-mono text-sm"/></label>
          <button type="submit" disabled={loading} data-testid="news-send" className="bg-berulia-ink text-berulia-beige overline px-6 py-3">{loading?"Envoi…":"Envoyer →"}</button>
        </form>
        <div className="bg-white border border-berulia-border p-6">
          <p className="overline mb-3">Abonné(e)s — {subs.length}</p>
          <ul className="space-y-1 text-sm max-h-96 overflow-y-auto">{subs.map(s=>(<li key={s.id} className="border-b border-berulia-border py-1">{s.email}</li>))}</ul>
        </div>
      </div>
    </div>
  );
}
